<template>
  <el-table :data="paystubs" style="width: 100%" stripe>
    <el-table-column prop="details" label="Details">
      <template slot-scope="scope">
        <el-row class="normal-word-wrap">
          <el-col :lg="12" :md="24">
            Medicare Tax: <strong>${{ scope.row.medicareTax }}</strong>
          </el-col>
          <el-col :lg="12" :md="24">
            Retirement Contributions: <strong>${{ scope.row.retirementAmt }}</strong>
          </el-col>
          <el-col :lg="12" :md="24">
            State Withholdings: <strong>${{ scope.row.stateTax }}</strong>
          </el-col>
          <el-col :lg="12" :md="24">
            Federal Withholdings: <strong>${{ scope.row.federalTax }}</strong>
          </el-col>
        </el-row>
      </template>
    </el-table-column>
    <el-table-column prop="state" label="State" width="75">
    </el-table-column>
    <el-table-column prop="paystubDate" :formatter="dateFormatter" label="Paystub Date" width="125">
    </el-table-column>
    <el-table-column prop="dateAdded" id="dateAdded" :formatter="dateFormatter" label="Created" width="110">
    </el-table-column>
    <template v-if="!readOnly">
      <el-table-column fixed="right" label="Actions" width="135">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="edit(scope.row)">Edit</el-button>
          <el-button type="danger" size="small" @click="remove(scope.row)" v-if="!scope.row.id">Delete</el-button>
        </template>
      </el-table-column>
    </template>
  </el-table>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    paystubs: {
      type: Array,
      default() {
        return [];
      },
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    dateFormatter(row, column, cellValue) {
      if (cellValue == null) {
        if (column.label === 'Created') {
          cellValue = Date();
        } else {
          return '';
        }
      }
      const date = moment(cellValue);
      return date.isValid() ? date.format('l') : '';
    },
    edit(paystub) {
      this.$emit('edit', paystub);
    },
    remove(paystub) {
      this.$emit('remove', paystub);
    },
  },
};

</script>
